const lcMsMzChemstationJcamp = `
##TITLE=Spectrum
##JCAMP-DX=5.00 $$ chemotion-converter-app (1.8.0)
##DATA TYPE=MASS SPECTRUM
##DATA CLASS=NTUPLES
##ORIGIN=
##OWNER=
##XUNITS=m/z
##YUNITS=Intensity
##NTUPLES=MULTIDIMENSIONAL
##VAR_NAME=T, m/z, Intensity
##SYMBOL=T, X, Y
##VAR_TYPE=PAGE, X, Y
##VAR_DIM=824, 369, 369
##UNITS=, m/z, Intensity
##PAGE=T= 1.1228166666666666
##XYDATA=(XY..XY)
943.7, 176.0
871.0, 362.0
849.9, 365.0
822.0, 366.0
786.6, 259.0
717.8, 268.0
695.0, 451.0
671.9, 682.0
656.7, 218.0
656.5, 566.0
643.2, 243.0
638.3, 740.0
636.7, 973.0
634.7, 311.0
630.8, 164.0
628.8, 284.0
620.8, 359.0
598.8, 207.0
582.4, 415.0
576.6, 410.0
562.9, 393.0
557.0, 288.0
554.8, 528.0
528.1, 326.0
524.8, 1419.0
486.7, 351.0
484.1, 302.0
455.1, 163.0
440.1, 871.0
439.1, 524.0
436.2, 213.0
434.3, 241.0
431.2, 2071.0
430.7, 249.0
427.8, 172.0
415.8, 649.0
415.1, 789.0
410.2, 273.0
409.7, 1192.0
406.6, 423.0
404.8, 957.0
402.8, 566.0
390.4, 154.0
388.8, 1174.0
383.0, 485.0
381.1, 401.0
378.1, 213.0
373.4, 466.0
370.2, 487.0
369.9, 430.0
369.0, 710.0
367.3, 495.0
366.9, 1395.0
365.0, 176.0
363.4, 176.0
360.4, 788.0
358.9, 504.0
356.8, 684.0
355.3, 156.0
354.0, 561.0
353.0, 731.0
348.4, 325.0
342.1, 236.0
336.1, 277.0
335.3, 170.0
332.6, 259.0
331.0, 261.0
326.1, 671.0
324.7, 321.0
323.0, 649.0
317.5, 178.0
317.0, 706.0
315.4, 1425.0
314.4, 484.0
313.5, 395.0
312.5, 237.0
312.0, 274.0
309.3, 474.0
307.1, 908.0
306.1, 162.0
304.2, 1206.0
301.1, 323.0
300.2, 830.0
299.0, 197.0
297.4, 640.0
296.9, 444.0
295.3, 774.0
294.8, 1440.0
294.1, 500.0
290.9, 295.0
290.6, 492.0
287.3, 291.0
283.7, 2229.0
282.0, 250.0
281.2, 1482.0
280.2, 292.0
279.2, 154.0
278.9, 359.0
278.6, 515.0
277.2, 954.0
276.2, 698.0
275.4, 1055.0
275.2, 694.0
274.9, 315.0
274.7, 265.0
274.3, 534.0
274.1, 343.0
273.4, 575.0
273.2, 409.0
272.1, 326.0
269.2, 1041.0
268.1, 181.0
267.2, 213.0
262.3, 683.0
256.9, 234.0
255.1, 208.0
254.0, 483.0
251.8, 400.0
251.1, 1342.0
250.2, 596.0
249.0, 1099.0
246.9, 338.0
246.2, 821.0
245.7, 503.0
245.3, 767.0
244.0, 509.0
243.7, 413.0
243.5, 443.0
237.2, 223.0
236.4, 237.0
236.2, 467.0
235.3, 153.0
232.2, 933.0
228.1, 672.0
227.1, 1310.0
223.0, 346.0
222.2, 564.0
221.7, 659.0
219.0, 179.0
218.0, 848.0
216.3, 671.0
214.1, 1910.0
212.1, 1898.0
207.1, 454.0
205.3, 719.0
205.1, 1184.0
204.8, 815.0
203.1, 1341.0
201.0, 873.0
199.9, 1837.0
198.1, 1070.0
197.7, 198.0
197.4, 782.0
196.6, 1089.0
195.9, 495.0
195.6, 654.0
195.3, 2179.0
194.8, 519.0
194.6, 924.0
193.9, 950.0
192.3, 1375.0
191.3, 1278.0
188.8, 267.0
188.3, 688.0
188.1, 790.0
187.3, 3030.0
186.4, 10914.0
186.2, 10409.0
185.9, 7283.0
185.2, 1396.0
184.8, 1225.0
184.1, 209.0
183.0, 1287.0
182.2, 1471.0
182.0, 1386.0
180.3, 624.0
179.4, 549.0
179.1, 614.0
178.4, 8340.0
178.2, 8688.0
178.0, 8896.0
177.2, 99344.0
176.0, 1209.0
175.1, 1221.0
173.6, 304.0
172.2, 4769.0
171.9, 1568.0
171.2, 476.0
170.0, 630.0
168.8, 216.0
167.2, 210.0
166.7, 293.0
166.4, 1399.0
166.0, 1617.0
164.7, 429.0
164.3, 2427.0
164.0, 1799.0
163.2, 295.0
163.0, 817.0
162.7, 253.0
162.3, 2094.0
161.9, 293.0
161.1, 659.0
160.9, 892.0
158.8, 811.0
158.2, 860.0
158.0, 1511.0
157.6, 1142.0
157.2, 1179.0
157.0, 1093.0
156.3, 2375.0
155.9, 772.0
155.1, 1544.0
154.9, 1692.0
154.7, 1331.0
154.2, 22184.0
153.9, 15580.0
153.6, 4012.0
153.1, 1230.0
152.8, 578.0
152.1, 996.0
151.5, 2841.0
151.3, 3728.0
151.0, 5287.0
150.0, 50632.0
148.9, 308.0
148.4, 803.0
147.8, 271.0
146.4, 739.0
145.1, 189.0
144.2, 221.0
143.3, 180.0
142.7, 1137.0
142.4, 558.0
142.1, 1718.0
139.1, 737.0
138.9, 888.0
138.3, 1405.0
138.1, 1484.0
137.7, 1437.0
137.4, 267.0
135.4, 1194.0
134.4, 929.0
134.2, 882.0
133.3, 3915.0
132.8, 1757.0
132.5, 581.0
132.3, 274.0
131.8, 209.0
130.5, 450.0
130.2, 758.0
130.0, 787.0
129.7, 1404.0
129.4, 1158.0
129.1, 4326.0
128.7, 557.0
128.1, 247.0
126.9, 480.0
125.3, 699.0
125.0, 454.0
124.7, 458.0
124.5, 650.0
124.1, 2572.0
123.8, 1255.0
123.3, 1643.0
122.9, 1238.0
122.7, 831.0
122.1, 7310.0
121.1, 78048.0
120.1, 135872.0
119.1, 2031616.0
117.9, 2778.0
117.1, 760.0
116.8, 431.0
116.4, 2041.0
116.0, 5486.0
115.0, 241.0
114.3, 1544.0
113.9, 951.0
113.4, 229.0
113.2, 245.0
112.8, 777.0
112.3, 1921.0
112.0, 969.0
111.8, 412.0
110.7, 1207.0
109.2, 568.0
108.5, 507.0
108.3, 1233.0
107.9, 562.0
107.3, 187.0
106.3, 1087.0
105.9, 362.0
105.3, 1865.0
105.0, 3478.0
104.2, 13681.0
103.9, 7938.0
103.7, 3570.0
103.2, 554.0
102.9, 1179.0
102.1, 4880.0
101.2, 2561.0
101.0, 3816.0
100.8, 4148.0
98.9, 679.0
97.5, 571.0
97.1, 165.0
96.4, 596.0
95.8, 572.0
95.3, 1074.0
95.0, 1183.0
94.6, 387.0
94.1, 452.0
93.8, 1033.0
93.4, 2132.0
93.2, 2356.0
93.0, 8547.0
92.2, 2426.0
92.0, 2747.0
91.2, 70968.0
90.6, 11736.0
89.8, 292.0
89.4, 1275.0
89.1, 1187.0
88.7, 364.0
88.4, 2716.0
88.2, 5839.0
86.5, 174.0
86.2, 337.0
85.2, 1226.0
84.8, 603.0
84.0, 523.0
82.3, 215.0
81.0, 2411.0
80.7, 1598.0
80.2, 1957.0
79.8, 822.0
79.2, 39824.0
78.2, 1324.0
77.7, 304.0
77.2, 2833.0
76.1, 480.0
75.8, 301.0
74.4, 435.0
72.9, 854.0
72.2, 810.0
71.9, 300.0
71.1, 627.0
70.3, 1805.0
68.8, 220.0
68.1, 404.0
67.3, 490.0
65.9, 585.0
65.3, 1216.0
65.0, 2231.0
64.5, 291.0
64.1, 1864.0
63.8, 639.0
63.2, 15748.0
62.3, 443.0
61.9, 754.0
61.7, 319.0
61.5, 173.0
61.2, 824.0
61.0, 641.0
60.2, 21408.0
60.0, 20752.0
57.2, 320.0
55.3, 849.0
##PAGE=T= 1.1384333333333334
##XYDATA=(XY..XY)
927.2, 221.0
890.9, 168.0
871.0, 768.0
849.9, 468.0
825.7, 284.0
822.0, 184.0
767.1, 241.0
755.8, 227.0
727.2, 150.0
717.8, 337.0
695.0, 354.0
671.9, 530.0
656.7, 438.0
656.5, 555.0
650.3, 220.0
646.8, 185.0
643.2, 499.0
638.3, 348.0
636.7, 750.0
634.7, 161.0
630.8, 201.0
628.8, 589.0
620.8, 182.0
598.8, 168.0
585.6, 168.0
582.4, 325.0
576.6, 322.0
562.9, 197.0
557.7, 279.0
557.0, 151.0
554.8, 257.0
528.1, 416.0
524.8, 1090.0
524.0, 176.0
486.7, 277.0
484.1, 383.0
452.7, 197.0
440.1, 1131.0
439.1, 409.0
436.2, 428.0
431.2, 1587.0
430.7, 343.0
430.5, 184.0
427.8, 336.0
422.1, 167.0
421.4, 208.0
416.7, 214.0
415.8, 504.0
415.1, 610.0
410.2, 155.0
409.7, 659.0
406.6, 544.0
404.8, 738.0
402.8, 571.0
394.2, 281.0
388.8, 540.0
386.8, 255.0
383.0, 378.0
381.1, 523.0
380.8, 153.0
379.9, 224.0
378.1, 429.0
377.0, 195.0
373.4, 597.0
370.2, 381.0
369.9, 338.0
369.0, 550.0
366.9, 1823.0
365.0, 347.0
363.4, 346.0
360.4, 610.0
358.9, 181.0
357.9, 239.0
356.8, 928.0
355.3, 300.0
354.0, 725.0
353.0, 482.0
342.1, 296.0
338.2, 157.0
336.1, 571.0
335.3, 332.0
332.6, 532.0
331.0, 210.0
327.3, 248.0
326.1, 1471.0
324.7, 253.0
323.9, 163.0
323.0, 977.0
320.7, 190.0
317.5, 350.0
317.0, 915.0
315.4, 1278.0
314.4, 622.0
313.5, 188.0
309.3, 371.0
307.3, 512.0
307.1, 784.0
304.2, 929.0
303.3, 155.0
301.1, 477.0
300.2, 1004.0
299.0, 395.0
297.4, 883.0
296.9, 563.0
295.3, 944.0
294.8, 1972.0
294.1, 255.0
290.9, 375.0
290.6, 385.0
288.9, 158.0
287.3, 153.0
283.7, 3178.0
283.1, 417.0
282.0, 316.0
281.1, 1585.0
280.2, 370.0
279.2, 405.0
278.9, 449.0
278.6, 687.0
277.2, 779.0
276.2, 561.0
275.4, 1302.0
274.9, 168.0
274.7, 318.0
274.3, 259.0
274.1, 268.0
273.4, 793.0
271.6, 194.0
269.2, 984.0
268.1, 358.0
267.2, 271.0
264.2, 237.0
262.3, 324.0
256.9, 294.0
256.1, 170.0
254.0, 378.0
251.8, 511.0
251.1, 1459.0
250.2, 662.0
249.0, 1408.0
246.9, 267.0
246.2, 563.0
245.7, 524.0
245.3, 1001.0
244.0, 654.0
243.5, 340.0
240.3, 248.0
237.9, 317.0
237.2, 280.0
236.4, 297.0
236.2, 605.0
232.1, 788.0
228.1, 793.0
227.1, 706.0
225.4, 161.0
225.0, 176.0
223.0, 294.0
222.2, 691.0
221.7, 924.0
219.0, 357.0
218.1, 677.0
217.1, 322.0
216.3, 522.0
214.1, 1191.0
212.1, 1949.0
209.4, 163.0
207.1, 514.0
205.3, 359.0
205.1, 938.0
204.8, 631.0
203.1, 1103.0
202.0, 259.0
201.1, 1245.0
200.3, 498.0
199.9, 1361.0
198.7, 228.0
198.1, 1395.0
197.4, 1242.0
196.6, 1421.0
196.3, 226.0
195.9, 637.0
195.5, 332.0
195.2, 1723.0
194.6, 1206.0
193.9, 1236.0
192.6, 245.0
192.3, 1080.0
191.3, 981.0
189.2, 207.0
188.8, 214.0
188.3, 534.0
188.1, 983.0
187.3, 2390.0
187.0, 1767.0
186.4, 12547.0
185.9, 7409.0
185.2, 1176.0
184.8, 738.0
184.1, 547.0
183.0, 981.0
182.2, 1250.0
181.9, 620.0
180.3, 449.0
179.4, 936.0
178.2, 9592.0
178.0, 9437.0
177.2, 112616.0
176.0, 1580.0
175.1, 1898.0
174.0, 190.0
173.7, 380.0
172.8, 238.0
172.2, 2800.0
171.9, 1312.0
171.2, 315.0
170.0, 965.0
166.7, 729.0
166.4, 990.0
166.0, 1173.0
165.0, 273.0
164.7, 371.0
164.3, 2869.0
164.0, 1387.0
163.2, 182.0
163.0, 393.0
162.3, 1903.0
161.9, 825.0
161.3, 152.0
161.1, 871.0
158.8, 1115.0
158.2, 1116.0
158.0, 1363.0
157.7, 952.0
157.2, 1182.0
157.0, 913.0
156.3, 1825.0
155.3, 738.0
155.0, 1556.0
154.7, 1791.0
154.2, 17832.0
153.6, 3466.0
153.1, 1281.0
152.8, 759.0
152.1, 1320.0
151.5, 2707.0
151.3, 5224.0
151.0, 6006.0
150.0, 56800.0
148.4, 1042.0
147.8, 154.0
146.4, 961.0
145.1, 398.0
144.2, 304.0
143.3, 501.0
142.7, 1483.0
142.1, 1575.0
140.1, 343.0
139.1, 384.0
138.9, 644.0
138.3, 1097.0
138.1, 1642.0
137.7, 1607.0
135.7, 310.0
135.4, 937.0
134.4, 738.0
134.2, 1016.0
133.3, 5469.0
133.0, 2655.0
132.8, 2222.0
132.5, 910.0
132.2, 319.0
131.8, 276.0
131.1, 258.0
130.2, 1004.0
130.0, 940.0
129.7, 1156.0
129.1, 4900.0
128.7, 734.0
128.1, 507.0
126.9, 183.0
125.3, 765.0
124.7, 227.0
124.1, 3457.0
123.8, 758.0
123.3, 1656.0
122.9, 1177.0
122.7, 418.0
122.1, 7539.0
121.1, 68040.0
120.1, 118432.0
119.1, 1626112.0
117.9, 2186.0
117.2, 497.0
117.0, 298.0
116.4, 2968.0
116.0, 6213.0
115.7, 1438.0
115.0, 175.0
114.3, 1367.0
113.9, 1258.0
113.1, 231.0
112.8, 375.0
112.3, 1365.0
112.0, 492.0
110.7, 556.0
110.2, 276.0
109.2, 681.0
108.5, 508.0
108.3, 992.0
108.0, 471.0
106.3, 1003.0
105.3, 1105.0
105.0, 2709.0
104.2, 9466.0
103.9, 5906.0
103.7, 3831.0
103.2, 779.0
102.9, 949.0
102.1, 5021.0
101.2, 4071.0
101.0, 4939.0
100.8, 5312.0
98.8, 547.0
97.5, 322.0
97.2, 467.0
96.4, 770.0
95.8, 444.0
95.1, 1239.0
94.6, 330.0
94.1, 713.0
93.8, 983.0
93.4, 1913.0
93.2, 1921.0
93.0, 8787.0
92.2, 1621.0
92.0, 1662.0
91.2, 58192.0
91.0, 56136.0
89.8, 367.0
89.4, 1281.0
89.2, 1115.0
89.0, 1105.0
88.4, 2559.0
88.2, 6706.0
86.2, 331.0
85.2, 1711.0
84.8, 527.0
84.0, 340.0
82.3, 267.0
82.0, 246.0
81.0, 2105.0
80.7, 1773.0
80.2, 2121.0
79.8, 473.0
79.2, 36736.0
79.0, 37608.0
77.7, 387.0
77.2, 2861.0
76.0, 595.0
75.6, 370.0
74.4, 346.0
74.0, 195.0
72.9, 660.0
71.9, 374.0
70.3, 936.0
70.0, 481.0
68.8, 449.0
68.1, 518.0
67.3, 631.0
65.9, 281.0
65.3, 936.0
65.0, 1852.0
64.5, 235.0
64.1, 1953.0
63.8, 621.0
63.2, 11430.0
62.1, 277.0
61.9, 358.0
61.7, 247.0
61.4, 240.0
61.2, 1012.0
60.8, 520.0
60.2, 20160.0
57.2, 252.0
55.3, 1103.0
##PAGE=T= 1.1540666666666666
##XYDATA=(XY..XY)
991.3, 169.0
936.9, 153.0
927.2, 276.0
920.6, 319.0
907.1, 285.0
895.8, 196.0
890.9, 233.0
871.0, 995.0
849.9, 367.0
828.9, 169.0
825.7, 593.0
784.8, 194.0
767.1, 487.0
755.8, 286.0
727.2, 287.0
717.8, 266.0
704.0, 277.0
695.0, 180.0
671.9, 257.0
656.7, 561.0
650.3, 446.0
646.8, 230.0
643.2, 643.0
636.7, 354.0
630.8, 163.0
628.8, 759.0
590.9, 180.0
582.4, 167.0
576.6, 371.0
557.7, 354.0
528.1, 327.0
524.8, 504.0
524.0, 349.0
519.6, 237.0
514.8, 238.0
484.1, 302.0
473.7, 150.0
452.7, 395.0
440.1, 870.0
439.0, 258.0
436.2, 549.0
433.8, 278.0
431.2, 724.0
430.7, 314.0
430.5, 353.0
427.8, 429.0
426.4, 195.0
422.1, 327.0
421.4, 261.0
416.7, 428.0
415.8, 245.0
415.1, 292.0
414.3, 155.0
409.6, 331.0
406.6, 425.0
404.8, 349.0
402.8, 444.0
394.2, 483.0
391.4, 178.0
386.8, 524.0
383.0, 190.0
381.1, 422.0
380.8, 295.0
379.9, 282.0
378.1, 551.0
377.0, 243.0
373.4, 464.0
370.2, 191.0
369.9, 173.0
369.0, 265.0
368.1, 226.0
366.9, 1398.0
365.0, 443.0
363.4, 441.0
360.4, 293.0
357.9, 488.0
356.8, 772.0
356.1, 159.0
355.3, 380.0
354.0, 580.0
353.0, 185.0
347.4, 157.0
344.4, 271.0
343.8, 153.0
342.1, 235.0
338.2, 193.0
336.1, 736.0
335.3, 423.0
334.9, 175.0
332.6, 686.0
331.9, 193.0
328.6, 202.0
327.3, 317.0
326.1, 1920.0
324.2, 203.0
323.8, 291.0
323.0, 934.0
320.7, 379.0
317.5, 446.0
317.0, 706.0
315.4, 756.0
315.1, 636.0
314.4, 483.0
313.5, 234.0
309.3, 403.0
307.3, 609.0
305.9, 188.0
304.2, 433.0
303.2, 299.0
301.1, 465.0
300.2, 842.0
299.0, 507.0
297.4, 765.0
296.9, 436.0
295.3, 1049.0
294.8, 1663.0
293.7, 345.0
290.9, 296.0
290.6, 194.0
288.9, 298.0
287.1, 585.0
283.7, 2772.0
283.1, 700.0
282.0, 251.0
281.1, 2071.0
280.1, 385.0
279.1, 741.0
278.6, 565.0
277.2, 425.0
276.2, 338.0
275.4, 1213.0
274.7, 244.0
273.4, 682.0
271.6, 243.0
269.2, 619.0
268.1, 457.0
267.3, 336.0
264.2, 297.0
263.1, 314.0
262.0, 227.0
258.0, 164.0
256.9, 234.0
256.1, 330.0
255.3, 188.0
254.0, 191.0
253.7, 182.0
251.8, 399.0
251.1, 1008.0
250.2, 735.0
249.0, 1197.0
246.2, 272.0
245.7, 445.0
245.3, 779.0
244.8, 251.0
244.0, 546.0
243.5, 201.0
241.0, 184.0
240.3, 312.0
237.9, 524.0
237.2, 255.0
236.4, 236.0
236.2, 478.0
235.2, 160.0
233.1, 182.0
232.0, 1065.0
228.0, 942.0
226.9, 531.0
225.3, 422.0
225.1, 420.0
223.9, 517.0
223.0, 275.0
222.2, 1000.0
221.7, 809.0
219.0, 458.0
218.1, 437.0
217.1, 678.0
216.3, 255.0
214.1, 576.0
212.1, 1646.0
210.3, 240.0
209.5, 303.0
208.1, 168.0
207.1, 811.0
205.1, 497.0
204.8, 303.0
203.9, 262.0
203.1, 720.0
202.8, 212.0
202.0, 329.0
201.1, 1284.0
200.3, 278.0
199.8, 1317.0
198.7, 286.0
198.1, 1072.0
197.4, 1330.0
196.6, 1094.0
196.3, 281.0
195.9, 719.0
195.1, 1656.0
194.6, 946.0
193.9, 978.0
193.0, 227.0
192.6, 502.0
192.3, 546.0
191.3, 455.0
189.2, 266.0
188.8, 151.0
188.3, 259.0
188.1, 742.0
187.4, 1916.0
187.0, 1433.0
186.3, 12922.0
185.2, 823.0
184.1, 1515.0
183.0, 487.0
182.2, 714.0
181.9, 565.0
181.0, 171.0
180.2, 248.0
179.4, 1053.0
178.1, 12117.0
177.2, 122024.0
176.0, 1286.0
175.1, 2002.0
173.9, 378.0
173.7, 383.0
172.8, 446.0
172.1, 1819.0
171.9, 1265.0
171.3, 241.0
170.0, 1119.0
167.2, 178.0
166.7, 1056.0
166.4, 608.0
166.0, 874.0
165.0, 590.0
164.3, 2382.0
162.2, 1308.0
161.9, 1387.0
161.3, 188.0
161.1, 707.0
160.6, 328.0
158.8, 942.0
158.2, 859.0
157.9, 1105.0
157.2, 864.0
157.0, 527.0
156.1, 2186.0
155.1, 1623.0
154.7, 1564.0
154.3, 13225.0
153.1, 990.0
152.8, 605.0
152.1, 1131.0
151.0, 7271.0
150.0, 55296.0
148.7, 271.0
148.4, 835.0
146.4, 742.0
146.0, 430.0
145.1, 531.0
144.3, 462.0
143.8, 224.0
143.3, 787.0
142.7, 1138.0
142.1, 1574.0
140.8, 228.0
140.1, 616.0
139.3, 179.0
138.9, 347.0
138.1, 1413.0
137.7, 1238.0
137.0, 270.0
135.7, 649.0
135.4, 470.0
134.1, 1011.0
133.3, 4769.0
132.8, 1841.0
132.5, 915.0
132.2, 540.0
131.8, 245.0
131.0, 342.0
130.2, 1089.0
130.0, 997.0
129.7, 821.0
129.1, 3710.0
128.7, 619.0
128.1, 652.0
126.1, 166.0
125.3, 708.0
124.1, 3117.0
123.4, 1355.0
122.9, 783.0
122.1, 6457.0
121.1, 57128.0
120.1, 95760.0
119.1, 1312256.0
117.9, 1336.0
117.2, 246.0
117.0, 233.0
116.2, 3022.0
116.0, 4770.0
115.7, 1392.0
114.3, 894.0
113.9, 999.0
113.1, 518.0
112.3, 811.0
112.0, 419.0
110.2, 349.0
109.2, 561.0
108.5, 394.0
108.3, 517.0
108.0, 391.0
107.1, 248.0
106.3, 880.0
105.0, 1435.0
104.2, 4998.0
104.0, 4704.0
103.7, 3251.0
103.2, 688.0
102.9, 743.0
102.1, 4043.0
101.2, 4753.0
101.0, 5097.0
100.8, 4785.0
98.8, 402.0
98.2, 170.0
97.2, 761.0
96.4, 597.0
95.8, 242.0
95.1, 965.0
94.6, 215.0
94.1, 781.0
93.8, 741.0
93.0, 6340.0
92.2, 1037.0
91.9, 827.0
91.0, 49968.0
89.8, 337.0
89.4, 1206.0
89.2, 1297.0
89.0, 1243.0
88.4, 2745.0
88.2, 6410.0
86.9, 268.0
86.2, 386.0
85.2, 2360.0
84.1, 266.0
83.2, 166.0
82.3, 212.0
82.0, 311.0
81.0, 1925.0
80.7, 1333.0
80.2, 1605.0
79.0, 33112.0
77.7, 561.0
77.2, 2343.0
76.0, 463.0
75.5, 578.0
74.4, 558.0
74.0, 510.0
72.9, 341.0
71.9, 294.0
70.0, 744.0
68.8, 576.0
68.1, 404.0
67.8, 246.0
67.3, 491.0
65.3, 436.0
65.0, 1021.0
64.8, 556.0
64.1, 1662.0
63.8, 532.0
63.1, 8177.0
62.1, 257.0
61.2, 1259.0
60.1, 18336.0
55.3, 850.0
##PAGE=T= 1.1696833333333334
##XYDATA=(XY..XY)
991.3, 208.0
936.9, 299.0
927.2, 220.0
920.6, 672.0
907.1, 596.0
895.8, 245.0
890.8, 258.0
871.0, 767.0
849.9, 186.0
828.9, 211.0
825.7, 767.0
814.3, 210.0
784.8, 388.0
767.1, 625.0
755.8, 228.0
727.2, 364.0
714.6, 359.0
712.6, 243.0
705.7, 161.0
704.0, 576.0
656.7, 437.0
650.3, 572.0
646.8, 184.0
643.2, 499.0
628.8, 586.0
576.7, 607.0
557.7, 279.0
545.1, 187.0
537.3, 224.0
528.1, 168.0
524.0, 446.0
519.6, 296.0
514.7, 599.0
495.4, 163.0
484.1, 157.0
473.7, 290.0
452.7, 506.0
444.0, 212.0
440.1, 406.0
438.9, 299.0
436.2, 428.0
435.0, 203.0
433.8, 352.0
430.5, 446.0
427.9, 368.0
426.4, 387.0
422.1, 417.0
421.4, 209.0
416.7, 548.0
414.3, 298.0
410.1, 160.0
409.6, 422.0
409.2, 236.0
408.3, 243.0
406.6, 211.0
402.8, 219.0
394.8, 212.0
394.3, 747.0
391.4, 221.0
386.8, 675.0
381.1, 228.0
380.8, 374.0
379.9, 224.0
378.1, 429.0
377.0, 195.0
373.4, 228.0
373.0, 167.0
368.1, 460.0
366.9, 712.0
365.0, 347.0
363.8, 267.0
363.4, 352.0
359.2, 266.0
357.9, 627.0
356.8, 405.0
356.1, 225.0
355.3, 299.0
354.0, 310.0
349.2, 238.0
344.4, 343.0
342.6, 200.0
338.2, 157.0
337.0, 301.0
336.1, 570.0
335.3, 332.0
332.6, 533.0
331.9, 240.0
330.3, 233.0
328.6, 255.0
328.0, 173.0
327.1, 423.0
326.1, 1471.0
325.1, 331.0
324.2, 408.0
323.8, 364.0
323.0, 572.0
320.7, 485.0
317.5, 349.0
317.0, 335.0
315.1, 880.0
314.4, 237.0
313.5, 189.0
311.0, 238.0
310.0, 153.0
309.4, 575.0
307.4, 465.0
305.9, 373.0
304.0, 172.0
303.2, 442.0
300.9, 366.0
300.1, 680.0
299.0, 397.0
298.0, 161.0
297.3, 486.0
296.9, 214.0
295.4, 1155.0
294.8, 1034.0
293.8, 574.0
292.8, 231.0
290.9, 154.0
288.9, 373.0
287.1, 1273.0
283.7, 1523.0
283.1, 801.0
281.1, 1586.0
280.1, 297.0
279.1, 1002.0
278.6, 297.0
277.1, 164.0
276.4, 354.0
275.4, 913.0
273.4, 377.0
272.2, 218.0
271.6, 195.0
269.2, 219.0
268.1, 505.0
267.3, 265.0
266.1, 252.0
264.2, 378.0
263.1, 468.0
262.1, 520.0
259.3, 171.0
258.0, 317.0
256.1, 421.0
255.3, 239.0
253.7, 354.0
251.8, 199.0
251.1, 467.0
250.2, 764.0
249.0, 685.0
248.2, 172.0
245.6, 299.0
245.3, 373.0
244.8, 315.0
244.2, 279.0
244.0, 335.0
243.0, 257.0
241.1, 379.0
240.3, 247.0
237.9, 565.0
237.2, 206.0
237.0, 212.0
236.1, 245.0
235.2, 195.0
233.1, 265.0
232.0, 961.0
231.2, 180.0
230.8, 440.0
228.3, 1226.0
227.0, 541.0
225.2, 1134.0
223.9, 1090.0
223.0, 289.0
222.2, 1298.0
221.7, 454.0
219.0, 359.0
218.1, 264.0
217.1, 943.0
214.0, 547.0
213.3, 198.0
212.1, 1396.0
211.6, 512.0
210.3, 300.0
209.5, 480.0
208.1, 300.0
207.1, 1157.0
205.3, 227.0
203.9, 342.0
203.3, 766.0
202.8, 264.0
202.0, 260.0
201.0, 1000.0
199.8, 963.0
198.7, 228.0
198.1, 496.0
197.3, 1065.0
196.6, 511.0
196.3, 223.0
195.8, 761.0
195.1, 1742.0
194.6, 459.0
193.9, 506.0
193.0, 462.0
192.6, 648.0
189.1, 242.0
188.1, 349.0
187.4, 1310.0
186.2, 14594.0
184.9, 1177.0
184.1, 2360.0
182.3, 352.0
181.8, 588.0
181.0, 333.0
180.1, 201.0
179.4, 877.0
178.1, 15319.0
177.2, 129496.0
176.0, 740.0
175.1, 1663.0
174.0, 588.0
172.8, 544.0
172.1, 1525.0
171.3, 302.0
170.0, 1086.0
166.7, 959.0
166.1, 994.0
165.0, 790.0
164.3, 1411.0
163.7, 637.0
163.0, 230.0
161.9, 1657.0
161.3, 153.0
161.1, 370.0
160.6, 745.0
158.8, 503.0
158.2, 515.0
157.8, 935.0
157.2, 397.0
156.1, 2481.0
155.1, 1581.0
154.2, 9731.0
153.1, 610.0
152.8, 314.0
152.1, 668.0
151.1, 9029.0
150.1, 57296.0
148.7, 582.0
148.4, 451.0
147.7, 162.0
147.0, 257.0
146.4, 350.0
146.0, 854.0
145.0, 598.0
144.2, 637.0
143.8, 284.0
143.3, 806.0
142.7, 525.0
142.1, 1432.0
140.8, 292.0
140.1, 713.0
139.3, 229.0
138.9, 205.0
138.1, 1042.0
137.7, 602.0
137.0, 356.0
135.7, 840.0
134.1, 851.0
133.2, 2986.0
132.8, 1112.0
132.5, 589.0
132.2, 753.0
131.0, 333.0
130.1, 962.0
129.1, 1739.0
128.1, 505.0
125.9, 284.0
125.2, 896.0
124.1, 3337.0
123.3, 915.0
122.9, 709.0
122.1, 4782.0
121.1, 46816.0
120.1, 72688.0
119.1, 1072128.0
116.3, 3036.0
116.0, 2783.0
115.7, 1021.0
115.1, 308.0
114.2, 530.0
113.9, 558.0
113.2, 728.0
112.3, 540.0
110.1, 449.0
109.2, 313.0
108.5, 210.0
108.0, 305.0
107.1, 507.0
106.1, 932.0
105.1, 577.0
104.3, 2546.0
104.0, 3085.0
103.7, 2247.0
103.2, 425.0
102.7, 806.0
102.1, 2541.0
101.0, 4210.0
100.2, 211.0
99.8, 245.0
98.8, 186.0
98.2, 280.0
97.2, 841.0
96.4, 287.0
95.1, 626.0
94.0, 699.0
93.0, 3687.0
92.1, 905.0
91.0, 43136.0
89.9, 254.0
89.2, 1307.0
89.0, 1296.0
88.2, 8548.0
86.9, 603.0
86.0, 508.0
85.2, 2733.0
84.1, 416.0
83.2, 235.0
82.0, 247.0
81.1, 2903.0
80.2, 881.0
79.0, 28352.0
77.7, 723.0
77.2, 1526.0
76.0, 227.0
75.5, 622.0
74.1, 1539.0
72.8, 169.0
71.9, 153.0
70.3, 1163.0
68.8, 449.0
68.1, 201.0
67.8, 310.0
67.3, 293.0
65.9, 153.0
64.8, 379.0
64.1, 1253.0
63.0, 7327.0
62.1, 254.0
61.2, 1343.0
60.2, 16520.0
55.3, 399.0
##PAGE=T= 1.1853166666666666
##XYDATA=(XY..XY)
991.3, 168.0
936.9, 382.0
920.6, 871.0
907.1, 771.0
895.8, 197.0
890.7, 259.0
871.0, 361.0
870.3, 180.0
834.7, 171.0
828.9, 171.0
825.7, 595.0
814.3, 264.0
784.8, 498.0
784.3, 224.0
767.1, 484.0
727.2, 287.0
714.6, 762.0
712.6, 500.0
705.7, 198.0
704.0, 744.0
656.7, 217.0
650.3, 444.0
643.2, 242.0
628.8, 280.0
598.6, 212.0
576.7, 785.0
545.1, 189.0
537.3, 280.0
524.0, 351.0
522.0, 200.0
519.6, 235.0
517.9, 208.0
514.7, 929.0
495.4, 316.0
481.2, 188.0
473.7, 367.0
464.2, 203.0
460.9, 279.0
457.2, 186.0
452.7, 395.0
444.0, 425.0
438.9, 380.0
436.2, 211.0
435.0, 254.0
433.8, 278.0
430.4, 437.0
428.0, 311.0
426.4, 494.0
423.9, 151.0
423.0, 198.0
422.1, 327.0
418.2, 188.0
416.7, 427.0
415.4, 157.0
414.3, 379.0
412.0, 599.0
410.0, 186.0
409.6, 332.0
409.2, 481.0
408.3, 496.0
401.5, 151.0
399.4, 220.0
398.0, 180.0
394.8, 427.0
394.3, 1110.0
391.4, 178.0
386.8, 524.0
380.8, 297.0
378.1, 213.0
373.0, 329.0
368.1, 595.0
366.8, 253.0
365.1, 232.0
363.7, 470.0
362.3, 273.0
359.2, 581.0
357.9, 487.0
356.0, 235.0
355.3, 156.0
352.9, 244.0
349.2, 440.0
344.9, 282.0
344.4, 271.0
342.6, 250.0
337.0, 520.0
336.1, 276.0
335.3, 170.0
334.7, 259.0
332.6, 259.0
331.9, 192.0
330.3, 474.0
328.8, 226.0
328.0, 214.0
327.1, 874.0
326.2, 756.0
325.0, 821.0
324.2, 722.0
323.1, 200.0
322.2, 188.0
320.7, 379.0
320.1, 240.0
319.8, 261.0
317.5, 178.0
315.1, 769.0
311.0, 487.0
310.3, 186.0
309.4, 742.0
308.5, 281.0
307.4, 228.0
305.9, 477.0
304.9, 246.0
304.0, 338.0
303.1, 502.0
300.9, 212.0
300.1, 543.0
299.0, 200.0
298.0, 198.0
297.3, 228.0
295.3, 1031.0
293.9, 746.0
292.8, 291.0
288.9, 380.0
287.1, 1670.0
283.7, 352.0
283.1, 620.0
281.1, 723.0
279.8, 239.0
279.0, 1295.0
276.4, 616.0
275.3, 691.0
274.2, 237.0
272.2, 441.0
270.3, 184.0
268.5, 228.0
268.1, 517.0
266.1, 319.0
264.3, 473.0
263.1, 456.0
262.1, 784.0
259.9, 234.0
258.0, 402.0
256.1, 454.0
255.3, 200.0
253.7, 451.0
250.1, 723.0
249.0, 182.0
248.2, 213.0
245.8, 201.0
244.8, 311.0
244.2, 353.0
243.0, 530.0
242.3, 190.0
241.1, 507.0
240.0, 225.0
237.9, 391.0
237.4, 276.0
237.1, 289.0
235.1, 341.0
234.1, 253.0
233.0, 292.0
232.4, 855.0
232.1, 671.0
231.2, 356.0
230.8, 855.0
229.9, 420.0
228.3, 1246.0
227.0, 461.0
225.2, 1894.0
223.9, 1410.0
223.0, 339.0
222.2, 1347.0
219.0, 182.0
218.1, 202.0
217.1, 826.0
214.1, 625.0
213.3, 302.0
212.2, 1336.0
211.5, 394.0
210.3, 237.0
209.9, 152.0
209.5, 568.0
208.1, 376.0
207.0, 1099.0
205.4, 393.0
203.9, 284.0
203.3, 761.0
202.8, 211.0
200.9, 865.0
200.3, 430.0
199.9, 498.0
199.1, 212.0
197.3, 673.0
195.8, 1032.0
195.1, 1571.0
193.9, 364.0
193.0, 594.0
192.6, 514.0
188.9, 424.0
187.2, 1287.0
186.2, 14593.0
185.4, 809.0
184.9, 1699.0
184.1, 2553.0
183.4, 173.0
182.3, 549.0
181.8, 396.0
181.0, 425.0
180.2, 168.0
179.4, 481.0
178.1, 16208.0
177.2, 128232.0
175.2, 1034.0
174.0, 622.0
172.8, 412.0
171.9, 1372.0
171.2, 267.0
170.0, 902.0
169.2, 229.0
167.2, 170.0
166.7, 557.0
166.1, 1408.0
165.0, 647.0
164.3, 720.0
163.7, 1281.0
162.9, 333.0
161.9, 1463.0
160.6, 1016.0
159.0, 156.0
158.2, 342.0
157.8, 549.0
157.1, 419.0
156.0, 2261.0
155.2, 1618.0
154.2, 6727.0
154.0, 6777.0
153.1, 355.0
152.1, 317.0
151.1, 9289.0
150.1, 55840.0
148.7, 771.0
147.7, 190.0
147.0, 319.0
146.0, 1200.0
145.0, 562.0
144.2, 712.0
143.3, 538.0
142.1, 989.0
140.8, 241.0
140.1, 516.0
139.3, 278.0
138.9, 167.0
138.0, 899.0
137.0, 364.0
136.4, 194.0
135.7, 648.0
134.9, 179.0
134.1, 501.0
133.1, 1699.0
132.2, 702.0
130.9, 326.0
130.3, 721.0
129.0, 431.0
128.1, 245.0
125.9, 518.0
125.2, 1244.0
124.1, 4209.0
123.1, 1418.0
122.1, 3447.0
121.1, 36544.0
120.1, 56664.0
119.1, 870016.0
116.3, 2390.0
115.1, 306.0
114.1, 396.0
113.2, 658.0
112.3, 697.0
112.1, 681.0
110.1, 604.0
107.9, 328.0
107.1, 653.0
106.1, 898.0
105.0, 259.0
104.1, 1523.0
102.6, 605.0
102.1, 1435.0
101.0, 2868.0
100.2, 265.0
99.8, 500.0
98.2, 328.0
97.2, 682.0
94.9, 292.0
94.4, 621.0
93.9, 729.0
93.1, 2282.0
92.2, 755.0
91.1, 36568.0
90.0, 362.0
89.0, 1265.0
88.2, 12160.0
86.8, 922.0
86.0, 647.0
85.2, 2652.0
84.1, 446.0
83.2, 276.0
81.1, 3668.0
80.2, 390.0
79.1, 27168.0
77.7, 560.0
77.2, 983.0
75.4, 540.0
74.1, 2867.0
72.8, 240.0
70.3, 1322.0
68.8, 221.0
67.8, 245.0
67.4, 167.0
65.9, 293.0
64.9, 213.0
64.1, 865.0
63.0, 6903.0
62.2, 305.0
61.2, 1216.0
60.2, 14969.0
##PAGE=T= 1.2009333333333334
##XYDATA=(XY..XY)
936.9, 301.0
920.6, 673.0
907.1, 597.0
890.7, 194.0
834.7, 334.0
825.7, 288.0
814.3, 213.0
784.8, 390.0
784.3, 281.0
775.6, 206.0
767.1, 235.0
727.2, 150.0
714.6, 989.0
712.6, 645.0
705.7, 161.0
704.0, 577.0
650.3, 218.0
598.6, 429.0
576.7, 607.0
565.8, 214.0
545.1, 155.0
537.3, 223.0
524.0, 179.0
522.0, 401.0
521.6, 179.0
517.9, 260.0
514.7, 921.0
495.4, 402.0
481.2, 374.0
473.7, 288.0
464.2, 266.0
460.7, 384.0
457.2, 231.0
452.7, 198.0
444.0, 545.0
438.9, 300.0
435.0, 204.0
430.3, 563.0
428.1, 313.0
426.4, 386.0
423.9, 290.0
423.0, 247.0
422.1, 167.0
418.2, 374.0
416.7, 212.0
415.4, 302.0
414.3, 298.0
412.0, 1148.0
410.1, 170.0
409.2, 618.0
408.3, 813.0
401.5, 185.0
399.4, 521.0
398.0, 357.0
394.8, 548.0
394.4, 1262.0
386.8, 255.0
384.4, 170.0
381.9, 273.0
381.1, 173.0
373.0, 419.0
368.1, 493.0
366.8, 319.0
365.2, 210.0
363.7, 554.0
362.3, 565.0
359.1, 799.0
357.9, 239.0
356.0, 218.0
352.9, 308.0
349.3, 623.0
344.9, 357.0
343.7, 198.0
342.6, 200.0
337.0, 747.0
334.7, 504.0
332.0, 247.0
330.3, 610.0
328.9, 177.0
328.0, 173.0
327.1, 1258.0
326.3, 354.0
325.1, 1499.0
324.1, 962.0
322.2, 372.0
320.2, 573.0
319.8, 783.0
315.0, 481.0
312.9, 171.0
311.0, 626.0
310.3, 229.0
310.0, 200.0
309.4, 608.0
308.5, 356.0
305.9, 374.0
304.9, 310.0
304.0, 431.0
303.1, 378.0
300.1, 403.0
298.4, 509.0
295.1, 849.0
294.0, 635.0
292.8, 231.0
291.0, 386.0
289.2, 551.0
287.1, 1297.0
284.7, 154.0
283.0, 359.0
280.9, 471.0
279.8, 494.0
279.0, 1873.0
276.4, 754.0
275.3, 515.0
274.2, 485.0
272.1, 566.0
271.2, 158.0
270.3, 364.0
269.5, 172.0
268.9, 268.0
268.5, 288.0
268.1, 484.0
266.1, 254.0
264.3, 534.0
263.1, 392.0
262.2, 855.0
259.9, 461.0
258.0, 316.0
256.2, 467.0
255.1, 185.0
253.7, 353.0
251.3, 206.0
249.9, 543.0
248.2, 172.0
245.9, 151.0
244.9, 227.0
244.2, 279.0
243.0, 683.0
242.3, 377.0
241.2, 430.0
240.0, 444.0
239.1, 172.0
237.9, 165.0
237.3, 437.0
235.0, 748.0
234.1, 435.0
233.0, 266.0
232.4, 1182.0
231.8, 495.0
230.8, 1068.0
229.9, 896.0
228.3, 972.0
227.1, 297.0
225.2, 2140.0
224.7, 463.0
223.9, 1082.0
223.0, 257.0
222.2, 1053.0
219.8, 184.0
218.0, 152.0
217.0, 538.0
214.1, 517.0
213.1, 503.0
212.1, 1184.0
211.6, 304.0
209.9, 185.0
209.5, 442.0
208.0, 396.0
207.0, 687.0
205.4, 494.0
203.9, 160.0
203.3, 500.0
200.9, 689.0
200.3, 702.0
199.1, 210.0
197.3, 321.0
197.0, 364.0
195.8, 936.0
195.1, 1468.0
193.8, 655.0
193.0, 511.0
192.4, 382.0
191.1, 236.0
190.2, 223.0
188.9, 672.0
187.2, 1405.0
186.1, 13241.0
185.4, 938.0
184.9, 1830.0
184.1, 1738.0
183.4, 215.0
182.3, 664.0
181.8, 162.0
181.0, 334.0
179.4, 224.0
178.1, 13499.0
177.2, 113152.0
175.1, 535.0
174.0, 526.0
172.8, 198.0
171.9, 1166.0
171.2, 210.0
169.9, 669.0
169.2, 467.0
167.7, 211.0
167.2, 229.0
166.8, 177.0
166.1, 1307.0
165.4, 382.0
165.0, 487.0
164.2, 466.0
163.7, 1627.0
163.0, 355.0
161.9, 974.0
160.6, 849.0
159.0, 159.0
158.2, 477.0
157.1, 692.0
156.0, 1540.0
155.2, 1347.0
154.0, 5271.0
153.0, 237.0
152.1, 315.0
151.1, 7042.0
150.2, 49432.0
148.7, 622.0
147.7, 150.0
147.0, 318.0
146.0, 1098.0
145.0, 464.0
144.1, 670.0
143.2, 222.0
142.0, 579.0
140.1, 239.0
139.2, 267.0
138.1, 845.0
137.0, 299.0
136.4, 240.0
135.7, 322.0
134.9, 198.0
134.1, 151.0
133.0, 1431.0
132.2, 427.0
130.8, 325.0
130.4, 826.0
129.1, 193.0
125.9, 638.0
125.2, 1340.0
124.1, 5270.0
123.1, 1793.0
122.0, 3075.0
121.1, 28584.0
120.1, 48760.0
119.1, 693504.0
116.3, 1551.0
115.9, 881.0
115.1, 208.0
114.0, 285.0
113.2, 384.0
112.0, 648.0
110.1, 667.0
107.8, 502.0
107.1, 510.0
106.1, 557.0
105.0, 258.0
104.1, 744.0
103.5, 416.0
102.1, 898.0
101.0, 1613.0
99.8, 713.0
98.2, 369.0
97.2, 451.0
94.4, 770.0
93.9, 793.0
93.1, 2486.0
92.2, 807.0
91.1, 29952.0
88.9, 1165.0
88.2, 15575.0
87.2, 1110.0
86.7, 1030.0
86.0, 500.0
85.2, 2213.0
84.1, 377.0
83.2, 323.0
81.0, 3703.0
79.9, 331.0
79.1, 26752.0
77.7, 271.0
77.2, 746.0
75.4, 362.0
74.1, 3610.0
73.4, 189.0
72.8, 234.0
70.3, 931.0
67.4, 205.0
65.9, 371.0
65.0, 368.0
64.1, 675.0
63.0, 6064.0
62.2, 323.0
61.1, 906.0
60.2, 12459.0
##PAGE=T= 1.2165666666666666
##XYDATA=(XY..XY)
936.9, 156.0
920.6, 321.0
907.1, 286.0
834.7, 425.0
832.9, 170.0
784.8, 197.0
784.3, 225.0
775.6, 373.0
765.2, 159.0
714.6, 763.0
712.6, 500.0
704.0, 278.0
598.6, 551.0
576.7, 291.0
565.8, 268.0
555.2, 158.0
522.0, 514.0
521.6, 345.0
517.9, 207.0
515.8, 172.0
514.6, 600.0
495.4, 316.0
481.2, 480.0
464.2, 271.0
460.6, 469.0
457.2, 187.0
444.0, 424.0
438.9, 156.0
433.0, 205.0
430.2, 671.0
428.1, 248.0
426.4, 194.0
423.9, 367.0
423.0, 199.0
418.2, 479.0
415.4, 384.0
414.3, 154.0
412.0, 1376.0
409.2, 480.0
408.3, 893.0
404.9, 185.0
404.1, 160.0
401.5, 151.0
399.4, 744.0
398.0, 456.0
394.4, 1055.0
384.4, 331.0
382.0, 486.0
381.1, 202.0
378.2, 186.0
373.0, 329.0
369.9, 181.0
369.0, 173.0
368.1, 266.0
367.2, 196.0
366.8, 253.0
365.9, 150.0
365.2, 263.0
363.7, 410.0
362.3, 728.0
359.7, 286.0
359.1, 711.0
352.9, 244.0
349.4, 684.0
346.1, 300.0
344.9, 281.0
343.7, 395.0
343.3, 178.0
338.2, 219.0
337.0, 874.0
335.9, 151.0
334.7, 667.0
333.9, 237.0
333.3, 215.0
332.1, 434.0
330.3, 474.0
328.9, 152.0
327.1, 1308.0
326.3, 453.0
325.1, 1981.0
324.1, 1048.0
322.2, 475.0
320.2, 863.0
319.8, 1288.0
315.0, 225.0
314.1, 169.0
312.9, 336.0
311.0, 486.0
310.0, 307.0
309.3, 380.0
308.4, 284.0
308.1, 241.0
305.9, 189.0
304.8, 331.0
304.0, 375.0
303.1, 191.0
300.2, 244.0
298.4, 1099.0
296.8, 179.0
295.1, 818.0
294.0, 373.0
293.4, 383.0
291.0, 853.0
289.2, 711.0
287.1, 624.0
284.2, 205.0
283.0, 193.0
280.9, 1013.0
279.8, 655.0
279.0, 2277.0
277.1, 502.0
276.4, 603.0
276.0, 755.0
275.1, 364.0
274.2, 751.0
272.1, 619.0
270.3, 465.0
268.9, 553.0
268.5, 233.0
268.1, 378.0
267.2, 259.0
265.9, 269.0
264.3, 416.0
263.1, 384.0
262.2, 673.0
259.9, 587.0
258.0, 164.0
256.2, 497.0
255.1, 348.0
253.7, 180.0
251.3, 258.0
249.9, 392.0
246.9, 214.0
243.0, 609.0
242.3, 482.0
241.3, 314.0
240.0, 585.0
239.2, 336.0
237.3, 482.0
235.0, 1109.0
234.1, 530.0
233.0, 172.0
232.4, 1119.0
231.8, 392.0
230.8, 908.0
229.9, 1187.0
229.0, 217.0
228.3, 499.0
227.1, 154.0
225.2, 1624.0
224.6, 283.0
223.9, 500.0
223.4, 200.0
222.1, 757.0
219.7, 382.0
217.0, 239.0
214.2, 328.0
213.0, 985.0
212.0, 1169.0
209.9, 151.0
209.5, 219.0
208.0, 280.0
207.0, 248.0
205.4, 382.0
203.3, 245.0
200.9, 350.0
200.3, 823.0
199.2, 153.0
196.9, 168.0
195.8, 609.0
195.1, 1483.0
193.8, 837.0
193.1, 384.0
192.3, 458.0
191.1, 483.0
190.2, 280.0
188.9, 771.0
187.9, 200.0
187.2, 1383.0
186.1, 11275.0
185.4, 715.0
184.9, 1464.0
184.1, 739.0
183.4, 174.0
182.3, 550.0
181.0, 171.0
178.1, 9965.0
177.1, 86952.0
175.8, 352.0
174.1, 319.0
171.9, 749.0
171.1, 178.0
170.5, 278.0
169.9, 421.0
169.2, 602.0
167.7, 427.0
167.2, 287.0
166.1, 796.0
165.1, 416.0
163.7, 1329.0
163.2, 359.0
162.3, 467.0
161.9, 513.0
161.3, 230.0
160.6, 447.0
159.0, 198.0
158.3, 473.0
157.1, 885.0
155.7, 1012.0
155.2, 894.0
154.0, 3689.0
152.9, 238.0
152.1, 342.0
151.2, 4108.0
150.1, 39176.0
148.8, 318.0
147.0, 441.0
146.0, 738.0
145.0, 327.0
143.9, 543.0
141.9, 383.0
139.2, 330.0
138.1, 686.0
137.0, 241.0
136.4, 192.0
136.0, 204.0
135.1, 154.0
133.0, 1121.0
132.0, 252.0
130.8, 312.0
130.4, 762.0
129.1, 300.0
125.9, 492.0
125.2, 993.0
124.8, 421.0
124.1, 4436.0
123.1, 1898.0
122.0, 2503.0
121.1, 21712.0
120.1, 42528.0
119.1, 544320.0
116.8, 514.0
116.4, 791.0
115.9, 755.0
114.0, 191.0
112.0, 657.0
111.2, 186.0
110.1, 682.0
109.0, 152.0
107.8, 645.0
107.2, 323.0
106.1, 196.0
105.0, 306.0
104.2, 371.0
103.4, 449.0
102.0, 752.0
101.1, 883.0
99.8, 657.0
98.9, 420.0
98.2, 343.0
97.2, 292.0
94.4, 581.0
93.9, 760.0
93.1, 2213.0
92.2, 770.0
91.1, 23080.0
88.9, 889.0
88.2, 14584.0
87.2, 1182.0
86.7, 846.0
86.0, 256.0
85.2, 1623.0
84.1, 222.0
83.3, 400.0
81.0, 2679.0
79.9, 395.0
79.1, 25344.0
77.2, 417.0
75.4, 182.0
74.1, 3505.0
72.8, 158.0
71.2, 158.0
70.3, 543.0
67.4, 165.0
65.9, 317.0
65.0, 701.0
64.1, 537.0
63.1, 5241.0
62.2, 239.0
61.0, 619.0
60.2, 10105.0
##PAGE=T= 1.2321833333333334
##XYDATA=(XY..XY)
990.2, 164.0
834.7, 333.0
832.9, 209.0
775.6, 478.0
765.2, 306.0
714.6, 360.0
712.6, 243.0
613.8, 263.0
598.6, 429.0
588.5, 224.0
565.8, 214.0
548.2, 243.0
522.0, 401.0
521.6, 436.0
514.6, 247.0
495.4, 162.0
481.2, 375.0
464.2, 238.0
460.6, 363.0
448.8, 164.0
444.0, 209.0
433.0, 258.0
430.2, 521.0
423.9, 290.0
418.2, 375.0
415.4, 302.0
412.0, 1004.0
409.2, 236.0
408.3, 765.0
404.9, 365.0
399.4, 672.0
398.0, 357.0
394.5, 675.0
394.0, 233.0
385.1, 154.0
384.4, 422.0
382.0, 599.0
381.1, 163.0
378.2, 231.0
373.1, 178.0
369.9, 357.0
369.0, 506.0
367.2, 266.0
365.9, 285.0
365.2, 211.0
364.1, 150.0
363.7, 191.0
362.3, 564.0
361.1, 150.0
359.7, 363.0
359.1, 407.0
354.2, 178.0
349.5, 739.0
346.1, 432.0
343.8, 508.0
343.2, 441.0
341.0, 238.0
338.3, 326.0
337.8, 159.0
336.9, 883.0
335.9, 289.0
334.7, 541.0
333.9, 488.0
333.3, 269.0
332.1, 556.0
330.3, 233.0
329.0, 164.0
327.1, 1015.0
326.3, 355.0
325.2, 2199.0
324.1, 757.0
323.5, 164.0
322.2, 371.0
320.3, 935.0
319.8, 1483.0
319.4, 275.0
314.1, 194.0
313.0, 748.0
311.0, 237.0
310.0, 385.0
309.3, 206.0
308.0, 347.0
304.8, 242.0
304.1, 308.0
300.2, 152.0
298.4, 1431.0
297.4, 249.0
296.8, 590.0
295.2, 1066.0
294.2, 176.0
293.4, 490.0
291.0, 1140.0
289.2, 551.0
284.2, 341.0
280.9, 1317.0
279.9, 560.0
279.0, 2064.0
277.5, 157.0
277.1, 1053.0
276.0, 1182.0
275.0, 783.0
274.1, 875.0
272.9, 187.0
272.0, 859.0
271.2, 306.0
270.3, 364.0
268.9, 714.0
268.1, 190.0
267.2, 538.0
265.9, 447.0
264.3, 207.0
263.1, 441.0
262.1, 442.0
259.9, 457.0
258.5, 220.0
256.2, 393.0
255.0, 515.0
253.3, 221.0
251.3, 207.0
250.1, 466.0
246.9, 431.0
242.9, 474.0
242.3, 412.0
241.8, 228.0
241.3, 151.0
240.0, 474.0
239.2, 516.0
237.3, 410.0
235.0, 1079.0
234.1, 413.0
232.2, 1061.0
230.8, 500.0
229.9, 951.0
229.0, 440.0
228.1, 346.0
225.2, 796.0
224.0, 306.0
223.4, 501.0
222.0, 793.0
219.6, 601.0
217.3, 270.0
214.9, 233.0
213.8, 274.0
213.0, 1704.0
212.0, 1537.0
210.9, 169.0
206.3, 189.0
205.4, 192.0
202.0, 260.0
200.3, 772.0
195.7, 246.0
195.1, 1352.0
193.8, 643.0
193.1, 269.0
192.3, 374.0
191.1, 622.0
190.2, 223.0
188.9, 604.0
187.9, 394.0
187.3, 966.0
186.1, 9804.0
184.8, 1093.0
182.3, 292.0
181.9, 308.0
179.1, 461.0
178.1, 6990.0
177.1, 62064.0
175.8, 426.0
174.2, 278.0
172.1, 529.0
170.6, 371.0
169.9, 172.0
169.2, 469.0
167.7, 592.0
167.2, 228.0
166.3, 291.0
165.9, 327.0
165.1, 498.0
164.1, 1180.0
163.2, 496.0
162.3, 819.0
161.2, 388.0
159.0, 165.0
158.3, 315.0
157.1, 706.0
156.6, 238.0
155.7, 985.0
155.2, 734.0
154.0, 2557.0
152.9, 300.0
152.1, 356.0
151.3, 2419.0
150.1, 27688.0
147.1, 638.0
146.3, 310.0
146.0, 309.0
145.0, 167.0
143.9, 415.0
143.1, 172.0
141.8, 298.0
139.1, 412.0
138.1, 439.0
137.1, 208.0
136.0, 245.0
135.0, 160.0
133.0, 794.0
132.0, 435.0
130.2, 773.0
129.1, 621.0
128.5, 288.0
125.9, 238.0
125.2, 440.0
124.8, 331.0
124.1, 2598.0
123.1, 1698.0
122.0, 1772.0
121.1, 15443.0
120.1, 34808.0
119.1, 428096.0
116.8, 401.0
116.4, 315.0
115.9, 494.0
112.1, 689.0
111.2, 361.0
110.1, 635.0
109.0, 293.0
107.8, 500.0
107.2, 243.0
105.0, 398.0
104.1, 355.0
103.4, 338.0
102.0, 432.0
101.1, 507.0
99.8, 450.0
98.9, 901.0
98.2, 329.0
97.2, 204.0
95.1, 165.0
94.4, 270.0
94.0, 535.0
93.0, 1721.0
92.1, 570.0
91.0, 17128.0
89.3, 655.0
88.9, 474.0
88.2, 11701.0
87.2, 799.0
86.7, 502.0
86.3, 277.0
85.2, 1276.0
83.3, 492.0
81.0, 1423.0
79.9, 359.0
79.1, 25160.0
77.0, 367.0
74.1, 2838.0
71.2, 277.0
70.3, 406.0
66.0, 232.0
65.0, 882.0
64.1, 708.0
63.1, 4237.0
61.0, 432.0
60.2, 8959.0
55.4, 255.0
##PAGE=T= 1.2478166666666666
##XYDATA=(XY..XY)
990.2, 203.0
834.7, 170.0
832.9, 168.0
775.6, 374.0
765.2, 388.0
718.2, 229.0
702.9, 208.0
663.4, 263.0
656.9, 184.0
613.8, 333.0
598.6, 212.0
588.5, 454.0
548.2, 306.0
522.0, 200.0
521.6, 339.0
515.0, 232.0
481.2, 190.0
464.2, 150.0
461.9, 279.0
460.6, 181.0
449.9, 157.0
448.8, 318.0
435.1, 163.0
433.0, 207.0
430.2, 254.0
423.9, 151.0
418.2, 189.0
415.4, 157.0
412.0, 434.0
411.4, 198.0
408.3, 441.0
404.9, 466.0
399.4, 392.0
398.5, 277.0
398.0, 181.0
394.5, 491.0
394.0, 311.0
392.9, 155.0
385.1, 296.0
384.4, 331.0
382.0, 456.0
378.2, 186.0
369.9, 456.0
369.0, 811.0
367.3, 293.0
365.9, 361.0
363.0, 176.0
362.3, 271.0
361.1, 287.0
359.7, 287.0
357.3, 201.0
354.2, 221.0
349.5, 532.0
346.1, 404.0
343.8, 401.0
343.1, 683.0
341.0, 300.0
338.3, 337.0
337.8, 309.0
337.0, 673.0
335.9, 419.0
334.7, 280.0
333.9, 629.0
333.3, 214.0
332.1, 433.0
329.0, 202.0
327.1, 657.0
326.3, 180.0
325.2, 1668.0
324.1, 386.0
323.5, 321.0
323.1, 227.0
322.3, 247.0
320.3, 785.0
319.8, 1063.0
319.4, 343.0
314.1, 152.0
313.0, 1094.0
310.8, 153.0
310.0, 301.0
309.3, 224.0
308.0, 490.0
304.2, 397.0
303.8, 177.0
303.3, 237.0
298.4, 1121.0
297.4, 440.0
296.8, 986.0
295.2, 1439.0
294.2, 151.0
293.4, 384.0
291.0, 919.0
289.2, 291.0
287.9, 205.0
286.8, 154.0
285.3, 199.0
284.3, 604.0
283.3, 260.0
282.2, 250.0
280.9, 1011.0
280.1, 512.0
279.0, 1367.0
277.1, 1360.0
276.0, 1189.0
275.1, 1219.0
274.1, 814.0
272.9, 421.0
272.0, 1025.0
271.2, 631.0
270.3, 183.0
268.9, 666.0
267.2, 695.0
265.9, 574.0
263.1, 434.0
262.0, 440.0
259.9, 265.0
258.5, 275.0
258.1, 329.0
256.2, 342.0
255.0, 844.0
253.2, 541.0
251.3, 391.0
250.1, 920.0
246.9, 552.0
245.3, 328.0
244.2, 151.0
242.9, 345.0
242.4, 294.0
241.8, 317.0
240.0, 247.0
239.2, 580.0
238.1, 152.0
237.2, 398.0
235.0, 676.0
234.1, 281.0
232.2, 1186.0
231.0, 221.0
229.9, 491.0
229.0, 669.0
228.0, 663.0
226.8, 448.0
225.2, 191.0
224.0, 648.0
223.4, 826.0
222.0, 867.0
219.6, 730.0
217.3, 548.0
214.9, 475.0
213.8, 218.0
213.0, 2122.0
212.1, 1848.0
210.9, 206.0
209.1, 220.0
206.3, 374.0
203.1, 162.0
202.0, 537.0
201.4, 197.0
200.2, 498.0
196.8, 251.0
196.2, 189.0
195.1, 1180.0
193.8, 306.0
193.1, 214.0
192.2, 223.0
191.1, 484.0
189.0, 409.0
187.9, 641.0
187.3, 654.0
186.1, 7717.0
184.7, 860.0
181.9, 457.0
181.2, 268.0
179.1, 550.0
178.1, 6022.0
177.2, 47312.0
175.8, 420.0
174.7, 154.0
174.2, 197.0
172.1, 650.0
170.6, 352.0
169.2, 231.0
167.7, 528.0
166.4, 221.0
165.8, 194.0
165.0, 452.0
164.1, 1663.0
163.2, 507.0
162.3, 941.0
161.1, 560.0
158.4, 150.0
157.1, 422.0
156.6, 299.0
155.7, 661.0
155.2, 908.0
154.0, 1920.0
152.9, 238.0
152.1, 373.0
151.3, 1878.0
150.1, 20664.0
147.1, 783.0
146.1, 296.0
144.0, 259.0
143.1, 267.0
141.8, 252.0
139.1, 430.0
138.0, 259.0
137.1, 251.0
136.0, 196.0
135.0, 198.0
133.0, 540.0
132.0, 579.0
130.8, 279.0
130.1, 1166.0
129.1, 1079.0
128.5, 467.0
124.8, 241.0
124.2, 1096.0
123.1, 1428.0
122.0, 1322.0
121.0, 12072.0
120.1, 26352.0
119.1, 337664.0
116.8, 201.0
115.9, 300.0
112.1, 817.0
111.2, 490.0
110.1, 557.0
109.0, 373.0
107.8, 243.0
107.2, 324.0
105.0, 466.0
104.1, 345.0
103.4, 164.0
102.0, 264.0
101.1, 618.0
100.2, 236.0
99.8, 200.0
98.9, 1170.0
98.3, 289.0
95.1, 547.0
94.0, 294.0
93.0, 1052.0
92.1, 316.0
91.0, 12653.0
89.3, 758.0
88.1, 9226.0
87.2, 333.0
86.8, 290.0
86.2, 386.0
85.2, 1481.0
83.8, 269.0
83.3, 446.0
81.1, 568.0
80.7, 557.0
79.9, 555.0
79.1, 27128.0
77.0, 447.0
74.1, 2094.0
73.6, 179.0
71.2, 341.0
70.2, 522.0
66.1, 191.0
65.0, 688.0
64.1, 987.0
63.1, 3213.0
61.3, 265.0
60.2, 9538.0
56.7, 204.0
55.4, 322.0
##PAGE=T= 1.26345
##XYDATA=(XY..XY)
990.2, 165.0
841.5, 151.0
775.6, 189.0
773.0, 271.0
765.2, 306.0
718.2, 465.0
702.9, 417.0
663.4, 596.0
656.8, 470.0
613.8, 264.0
588.5, 583.0
548.2, 243.0
530.9, 173.0
521.6, 172.0
515.0, 292.0
483.4, 238.0
472.7, 173.0
463.0, 204.0
461.9, 354.0
449.9, 302.0
448.8, 404.0
445.2, 163.0
439.3, 218.0
435.1, 201.0
422.5, 165.0
420.0, 322.0
411.4, 399.0
408.2, 240.0
404.9, 447.0
398.5, 351.0
394.5, 392.0
394.0, 393.0
392.9, 191.0
385.2, 391.0
384.4, 169.0
383.0, 263.0
382.0, 225.0
380.0, 501.0
369.9, 357.0
369.0, 837.0
367.3, 219.0
366.6, 261.0
365.9, 286.0
365.2, 154.0
361.1, 362.0
359.8, 153.0
357.3, 361.0
356.3, 211.0
354.2, 177.0
353.2, 218.0
349.5, 258.0
348.4, 322.0
346.1, 252.0
344.1, 242.0
343.1, 748.0
341.0, 239.0
340.3, 160.0
338.3, 232.0
337.8, 393.0
337.0, 409.0
335.8, 422.0
333.9, 489.0
333.1, 150.0
332.1, 229.0
330.0, 282.0
329.0, 186.0
328.4, 152.0
327.2, 532.0
326.9, 533.0
325.2, 894.0
323.5, 408.0
323.1, 400.0
322.4, 398.0
320.4, 520.0
319.8, 490.0
319.4, 269.0
316.1, 170.0
314.2, 193.0
313.0, 1237.0
310.8, 294.0
310.0, 156.0
309.3, 223.0
308.0, 486.0
304.2, 388.0
303.8, 343.0
303.3, 370.0
298.9, 166.0
298.4, 558.0
297.4, 575.0
296.8, 1202.0
296.1, 221.0
295.2, 1568.0
293.9, 201.0
293.4, 194.0
292.1, 163.0
291.1, 500.0
287.9, 284.0
287.3, 228.0
286.8, 259.0
285.3, 214.0
284.3, 764.0
283.3, 422.0
282.2, 485.0
280.9, 469.0
280.2, 549.0
279.1, 712.0
277.1, 1045.0
275.9, 830.0
275.1, 1427.0
274.1, 855.0
273.0, 653.0
272.0, 864.0
271.2, 1019.0
268.9, 524.0
267.7, 292.0
267.2, 539.0
265.9, 447.0
262.9, 424.0
262.0, 329.0
259.6, 167.0
258.1, 689.0
256.1, 400.0
255.1, 1201.0
253.2, 879.0
251.3, 671.0
250.1, 1196.0
246.9, 429.0
245.3, 660.0
244.2, 185.0
242.9, 290.0
242.4, 384.0
241.8, 368.0
239.2, 419.0
238.0, 394.0
237.2, 689.0
235.0, 229.0
234.0, 218.0
232.2, 922.0
231.1, 405.0
230.3, 209.0
229.0, 693.0
228.0, 1013.0
226.8, 733.0
224.0, 844.0
223.4, 892.0
222.4, 550.0
221.9, 884.0
219.6, 548.0
217.3, 723.0
214.9, 611.0
213.0, 1928.0
212.1, 2391.0
210.9, 167.0
210.0, 178.0
209.1, 447.0
206.3, 477.0
203.1, 312.0
202.0, 736.0
201.4, 397.0
200.2, 243.0
196.8, 535.0
196.2, 260.0
195.2, 1016.0
192.1, 249.0
191.1, 238.0
189.1, 440.0
187.9, 705.0
187.2, 850.0
186.2, 6459.0
185.1, 926.0
184.7, 737.0
181.9, 454.0
181.2, 339.0
179.1, 562.0
178.1, 6454.0
177.2, 41648.0
175.8, 465.0
174.7, 299.0
172.2, 860.0
170.7, 287.0
167.8, 352.0
165.0, 346.0
164.1, 2060.0
163.2, 427.0
162.3, 726.0
161.1, 639.0
158.8, 273.0
157.0, 235.0
156.6, 238.0
156.1, 191.0
155.7, 384.0
155.2, 1123.0
154.1, 2414.0
152.1, 388.0
151.2, 2489.0
150.1, 20624.0
149.0, 164.0
147.1, 749.0
146.1, 369.0
144.1, 234.0
143.1, 405.0
141.8, 171.0
139.1, 311.0
137.1, 286.0
135.0, 248.0
133.2, 755.0
132.0, 477.0
130.9, 294.0
130.1, 1240.0
129.2, 1574.0
128.5, 498.0
124.8, 194.0
124.2, 809.0
123.8, 490.0
123.1, 1033.0
122.6, 231.0
122.0, 882.0
121.1, 10936.0
120.1, 18856.0
119.1, 264000.0
116.1, 537.0
115.0, 216.0
112.2, 642.0
111.1, 509.0
110.1, 448.0
109.0, 296.0
108.1, 239.0
107.1, 370.0
105.1, 511.0
104.1, 1041.0
102.0, 338.0
101.1, 784.0
100.5, 162.0
100.2, 227.0
98.9, 900.0
98.4, 259.0
95.1, 943.0
93.9, 185.0
93.1, 628.0
92.2, 176.0
91.0, 9938.0
89.2, 773.0
88.1, 8730.0
86.7, 322.0
86.2, 361.0
85.2, 1877.0
83.8, 341.0
83.3, 294.0
82.6, 157.0
81.2, 941.0
80.6, 358.0
80.0, 823.0
79.1, 28464.0
76.9, 601.0
75.0, 247.0
74.1, 1456.0
73.0, 212.0
71.2, 269.0
70.2, 418.0
66.1, 155.0
65.0, 339.0
64.0, 1127.0
63.0, 2649.0
61.4, 249.0
60.1, 10768.0
56.7, 272.0
55.4, 301.0
`;

export default lcMsMzChemstationJcamp;
